/**
 * Canonical URL utilities to ensure consistent URLs across the site
 * This prevents duplicate content issues with www vs non-www domains
 */

// Your preferred canonical domain (choose one and stick with it)
// Option 1: With www
export const CANONICAL_DOMAIN = 'https://www.kiracar.com'

// Option 2: Without www (uncomment if you prefer this)
// export const CANONICAL_DOMAIN = 'https://kiracar.com'

/**
 * Generate a canonical URL with the enforced domain
 * This ensures all canonical tags point to the same domain regardless of how users access the site
 *
 * IMPORTANT: No trailing slashes - our React Router routes use paths without trailing slashes
 * (e.g. /en, /fr/terms, /fr/cars/...). Canonical must match the exact URL we serve to avoid
 * "Alternate page with proper canonical tag" errors in Google Search Console.
 */
export function getCanonicalUrl(path: string): string {
  // Remove leading/trailing slashes and normalize
  let cleanPath = path.startsWith('/') ? path.slice(1) : path
  cleanPath = cleanPath.endsWith('/') ? cleanPath.slice(0, -1) : cleanPath

  if (!cleanPath) {
    return CANONICAL_DOMAIN
  }

  return `${CANONICAL_DOMAIN}/${cleanPath}`
}

/**
 * Get the canonical domain (useful for other purposes)
 */
export function getCanonicalDomain(): string {
  return CANONICAL_DOMAIN
}
